export default function ({state, commit, dispatch}, value) {
    let cb = () => {
    };
    let data = {};
    if (value && value.data) {
        if (value.cb) cb = value.cb;
        if (value.data) data = value.data;
    } else {
        return;
    }
    commit('cb', cb);

    if (state.loading || state.filter) {
        commit('cb');
        return;
    }
    commit('loading', true);
    axios({
        method: 'post',
        url: '/tourclient/api/GiftCertificate/all',
        data: data,
        requestId: 'tourclient/api/GiftCertificate/all'
    }).then(({data}) => {
        let error = '';
        if (!data) {
            error = 'Не удалось загрузить настройки: Сертификатов';
        } else if (data.ResultQueryInfo && data.ResultQueryInfo.UserMessages) {
            error = data.ResultQueryInfo.UserMessages;
        }
        if (error) {
            window.app.$notify.error({
                title: 'Ошибка',
                message: error,
            });
        }
        commit('items', data);
    }).catch(e => {
        if (!e) return;
        commit('loading', false);
        dispatch('error', e, {root: true});
    });
}